export { default } from './SoundMoney';
